import React from 'react'
import { Redirect, Route, RouteProps } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { getUser, isAuthorized, isFetching } from '../../store/settings/settings.selectors'
import { UserSettings } from '@professocialApi/professocial-core-frontend-api'

const UnauthenticatedRoute = ({ component: Component, path, children }: RouteProps) => {
  const user: UserSettings | undefined = useSelector(getUser)
  const authorized: boolean = useSelector(isAuthorized)
  const fetching: boolean = useSelector(isFetching)

  if (!user && !authorized && !fetching) {
    return children ? <Route path={path}>{children}</Route> : <Route component={Component} path={path} />
  }

  return <Redirect to='/' />
}

export default UnauthenticatedRoute
